import React from "react";
import { Card, CardContent, Typography, Grid, Box } from "@material-ui/core";
import { client } from "../../../service/ApolloClient/ApolloClient";
import { QUERY_CHEQUE_STATS_BY_USER } from "../../../service/ApolloClient/ApolloQueries";
import { formatString } from "../../UI/react-persian/PersianNumber";
import NumberFormat from "react-number-format";

class ChequeStatusCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      owner: { bounced: 0, bouncedAmount: 0, cashed: 0, cashedAmount: 0, current: 0, currentAmount: 0 },
      giver: { bounced: 0, bouncedAmount: 0, cashed: 0, cashedAmount: 0, current: 0, currentAmount: 0 },
      total: { bounced: 0, bouncedAmount: 0, cashed: 0, cashedAmount: 0, current: 0, currentAmount: 0 },
      loading: true,
    };
  }

  componentDidMount() {
    this.fetchStats();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.userId !== this.props.userId) {
      this.fetchStats();
    }
  }

  fetchStats = async () => {
    try {
      const result = await client.query({
        query: QUERY_CHEQUE_STATS_BY_USER,
        variables: { userId: parseInt(this.props.userId) },
        fetchPolicy: "network-only",
      });
      
      const { owner, giver, total } = result.data.chequeStatsByUser;
      this.setState({ owner, giver, total, loading: false });
    } catch (error) {
      console.error("Error fetching cheque stats:", error);
      this.setState({ loading: false });
    }
  };

  renderStatBox = (label, count, amount, color) => (
    <Grid item xs={4}>
      <Box style={{ 
        textAlign: "center", 
        padding: "12px 8px", 
        backgroundColor: color + "15",
        borderRadius: 8,
        border: `1px solid ${color}30`,
      }}>
        <Typography variant="body2" style={{ color: color, fontWeight: "bold", marginBottom: 4 }}>
          {label}
        </Typography>
        <Typography variant="h6" style={{ color: color, fontWeight: "bold" }}>
          {formatString(count)}
        </Typography>
        <Typography variant="caption" style={{ color: color, display: "block", marginTop: 4 }}>
          <NumberFormat value={amount} thousandSeparator={true} displayType={"text"} suffix=" ریال" />
        </Typography>
      </Box>
    </Grid>
  );

  renderGroup = (title, stats, bgColor) => (
    <Grid item xs={12} md={4}>
      <Box style={{ backgroundColor: bgColor, borderRadius: 8, padding: 16 }}>
        <Typography variant="subtitle1" style={{ fontWeight: "bold", marginBottom: 12, textAlign: "center" }}>
          {title}
        </Typography>
        <Grid container spacing={1}>
          {this.renderStatBox("برگشتی", stats.bounced, stats.bouncedAmount, "#f44336")}
          {this.renderStatBox("پاس شده", stats.cashed, stats.cashedAmount, "#4caf50")}
          {this.renderStatBox("جاری", stats.current, stats.currentAmount, "#ff9800")}
        </Grid>
      </Box>
    </Grid>
  );

  render() {
    const { owner, giver, total, loading } = this.state;

    if (loading) {
      return (
        <Card style={{ marginBottom: 16 }}>
          <CardContent>
            <Typography>در حال بارگذاری...</Typography>
          </CardContent>
        </Card>
      );
    }

    return (
      <Card style={{ marginBottom: 16 }}>
        <CardContent>
          <Typography variant="h6" gutterBottom style={{ fontWeight: "bold", marginBottom: 16 }}>
            خلاصه وضعیت چک‌ها
          </Typography>
          <Grid container spacing={2}>
            {this.renderGroup("در نقش مالک چک", owner, "#fafafa")}
            {this.renderGroup("در نقش دهنده چک", giver, "#fafafa")}
            {this.renderGroup("مجموع", total, "#e3f2fd")}
          </Grid>
        </CardContent>
      </Card>
    );
  }
}

export default ChequeStatusCard;
